// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';

import { loadSurveys } from 'actions/surveys';
import type { Survey as SurveyType } from 'actions/surveys';

import SurveyResult from 'components/SurveyResult';
import SurveyResultOpen from 'components/SurveyResult/SurveyResultOpen';
import ReportState from 'components/ReportState';

// import SurveyItem from './SurveyItem';
import NewSurvey from './NewSurvey';

type Props = {
  // redux
  surveys: Array<SurveyType>,
  onLoadSurveys: typeof loadSurveys,
};

class Surveys extends React.Component<Props> {
  componentDidMount() {
    this.props.onLoadSurveys();
  }

  render() {
    const { surveys } = this.props;

    return (
      <div className="animated fadeIn">
        <Container fluid>
          <Row>
            <Col>
              {surveys.map(survey => {
                const answersLookup = survey.answers.reduce(
                  (acc, { answerId, text }) => {
                    acc[answerId] = text;
                    return acc;
                  },
                  {}
                );
                const results = survey.votes.reduce(
                  (acc, { selectedAnswerId }) => {
                    const a = answersLookup[selectedAnswerId];
                    acc[a] = acc[a] || 0;
                    acc[a]++;
                    return acc;
                  },
                  {}
                );
                const votes = survey.answers.reduce((acc, { text }) => {
                  acc[text] = results[text] || 0;
                  return acc;
                }, {});
                const responses = survey.responses.map(r => r.text);
                return (
                  <Link
                    key={survey.surveyId}
                    to={`/survey/${survey.surveyId}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {survey.type === 'closed' ? (
                      <SurveyResult
                        title={survey.title}
                        votes={votes}
                        statusComponent={
                          !!survey.deleted ? (
                            <ReportState state="deleted" />
                          ) : null
                        }
                      />
                    ) : (
                      <SurveyResultOpen
                        title={survey.title}
                        responses={responses}
                        statusComponent={
                          !!survey.deleted ? (
                            <ReportState state="deleted" />
                          ) : null
                        }
                      />
                    )}
                  </Link>
                );
              })}
            </Col>
            <Col xs="12" sm="12" md="12" lg="5" xl="5">
              <NewSurvey />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ surveys: { all: surveys } }) => ({
  surveys,
});
const mapDispatchToProps = dispatch => ({
  onLoadSurveys: (...args) => dispatch(loadSurveys(...args)),
});

const SurveysContainer = connect(mapStateToProps, mapDispatchToProps)(Surveys);

export default SurveysContainer;



// WEBPACK FOOTER //
// ./src/views/Surveys/Surveys.js